import { CustomStringParam, FilterType, SchemaFilterType } from '@ui/src';
import { ApplicatinSchemeType } from '../types';

export const columns = [
  {
    name: 'id',
    label: '',
    hidden: true,
  },
  {
    name: 'name',
    label: 'Name',
    sortable: false,
  },
  {
    name: 'type',
    label: 'Client type',
    sortable: false,
  },
  {
    name: 'active',
    label: 'Active',
    sortable: false,
  },
  {
    name: 'visible',
    label: 'Visible',
    sortable: false,
  },
];

export const columnsLabels = {
  name: 'Name',
  type: 'Client type',
  active: 'Active',
  visible: 'Visible',
};

export const schema = {
  type: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  active: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  visible: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
};

export const filtersSchema = [
  {
    name: 'active',
    type: FilterType.RADIO,
    fields: [
      {
        name: 'active',
        title: 'Active',
        value: 'true',
      },
      {
        name: 'active',
        title: 'Inactive',
        value: 'false',
      },
    ],
  },
  {
    name: 'visible',
    type: FilterType.RADIO,
    fields: [
      {
        name: 'visible',
        title: 'Visible',
        value: 'true',
      },
      {
        name: 'visible',
        title: 'Not visible',
        value: 'false',
      },
    ],
  },
  {
    name: 'type',
    type: FilterType.CHECKBOX,
    fields: [
      {
        name: 'type',
        title: 'Individual',
        value: ApplicatinSchemeType.INDIVIDUAL,
      },
      {
        name: 'type',
        title: 'Corporate',
        value: ApplicatinSchemeType.CORPORATE,
      },
      {
        name: 'type',
        title: 'Company official',
        value: ApplicatinSchemeType.COMPANY_OFFICIAL,
      },
    ],
  },
];
